// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"4e5ca311","796":"53bf703f"}[chunkId] + ".chunk.js";
};